import React from "react"
import { ComboBox } from "@src/components/MimecastReskin"

export const ComboBoxWithOverlap = (props) => {
  return <ComboBox {...props} menuZIndex="9999" />
}
